import {forwardRef} from 'react';
import {Button} from '@ezcater/tapas';
import useTranslation from 'next-translate/useTranslation';

import restaurantPartnerSvg from '@/assets/images/home/restaurant-partner.svg';
import useTracking from '@/hooks/useTracking';
import {CATERING_GROWTH_PLATFORM_PATH} from '@/paths';

const RestaurantPartner = forwardRef<HTMLElement, unknown>(function RestaurantPartner(_props, ref) {
  const {t} = useTranslation('home');
  const {trackClick} = useTracking();

  const trackCtaClick = () => {
    trackClick('restaurant-partner-cta');
  };

  return (
    <section
      ref={ref}
      className="mx-auto mb-0 mt-8 flex max-w-[1200px] flex-col items-center justify-between gap-12 bg-green-50 px-6 py-12 md:px-8 desktop924:mx-6 desktop924:mb-16 desktop924:mt-12 desktop924:flex-row desktop924:justify-center desktop924:rounded-2xl desktop924:p-12 desktop1248:mx-auto"
    >
      <div className="order-2 my-auto gap-6 text-center desktop924:order-1 desktop924:w-[460px] desktop924:px-0 desktop924:text-left">
        <h2 className="text-[32px] font-bold leading-[38px]">{t('restaurantPartner.title')}</h2>
        <p className="mt-2 desktop924:pr-12">{t('restaurantPartner.description')}</p>
        <Button
          render={
            <a
              className="block w-full px-4 py-3 text-center font-bold text-white hover:text-white hover:no-underline"
              data-testid="restaurant-partner-cta"
              href={CATERING_GROWTH_PLATFORM_PATH}
            >
              {t('restaurantPartner.cta')}
            </a>
          }
          className="mt-8 w-full rounded-full bg-green-700 hover:bg-green-600 active:bg-green-800 tablet:w-auto"
          onClick={trackCtaClick}
        />
      </div>
      <picture className="order-1 w-[240px] md:w-[320px] desktop924:order-2 desktop924:h-full desktop924:w-[360px]">
        <img
          alt=""
          className=""
          decoding="async"
          height={323}
          loading="lazy"
          src={restaurantPartnerSvg.src}
          width={360}
        />
      </picture>
    </section>
  );
});

export default RestaurantPartner;
